import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseMailboxFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 4C3.5 3.17157 4.17157 2.5 5 2.5H19C19.8284 2.5 20.5 3.17157 20.5 4V20C20.5 20.8284 19.8284 21.5 19 21.5H5C4.17157 21.5 3.5 20.8284 3.5 20V4ZM5.25 6C5.25 5.58579 5.58579 5.25 6 5.25H18C18.4142 5.25 18.75 5.58579 18.75 6C18.75 6.41421 18.4142 6.75 18 6.75H6C5.58579 6.75 5.25 6.41421 5.25 6ZM13.25 10.5C13.25 11.1904 12.6904 11.75 12 11.75C11.3096 11.75 10.75 11.1904 10.75 10.5C10.75 9.80964 11.3096 9.25 12 9.25C12.6904 9.25 13.25 9.80964 13.25 10.5Z"
        fill={color}
      />
    </svg>
  );
};
